import { OrderType } from '~/enums'
import { OrderTypePresentation } from '~/presentation/OrderTypePresentation'

// The order types a customer may choose. Delivery stays a backend order type but is absent from
// the customer interface, so every selector, guard, and request builder derives from this list.
export const CUSTOMER_SELECTABLE_ORDER_TYPES: readonly OrderType[] = [
  OrderType.DINE_IN,
  OrderType.PICKUP
]

export const SEARCH_ORDER_TYPES = CUSTOMER_SELECTABLE_ORDER_TYPES.map((value) => ({
  value,
  title: OrderTypePresentation[value].label,
  description: OrderTypePresentation[value].helpText
}))
